import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppData } from 'src/app/app.data';
import { AppSettings } from 'src/app/app.settings';

@Component({
  selector: 'app-available-balance-dialog',
  templateUrl: './available-balance-dialog.component.html',
  styleUrls: ['./available-balance-dialog.component.scss']
})
export class AvailableBalanceDialogComponent implements OnInit {

  constructor(
    public appSettings:AppSettings,
    private appData: AppData,
    public dialogRef: MatDialogRef<AvailableBalanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onOK(){
    this.dialogRef.close(true);
  }

}
